import TabHeader from './TabHeader';
export default TabHeader;
